type ScoredSearchResult = {
  score?: number | null;
};

export const DEFAULT_MINIMUM_RELATIVE_SEARCH_SCORE = 0.1;
export const MINIMUM_RELATIVE_SEARCH_SCORE_STORAGE_KEY = 'minimumRelativeSearchScore';

const isValidRelativeSearchScore = (score: number): boolean => (
  Number.isFinite(score) && score >= 0 && score <= 1
);

export const getMinimumRelativeSearchScore = (): number => {
  const storedValue = localStorage.getItem(MINIMUM_RELATIVE_SEARCH_SCORE_STORAGE_KEY);
  const storedScore = Number(storedValue);

  return storedValue !== null && isValidRelativeSearchScore(storedScore)
    ? storedScore
    : DEFAULT_MINIMUM_RELATIVE_SEARCH_SCORE;
};

export const setMinimumRelativeSearchScore = (score: number): void => {
  if (isValidRelativeSearchScore(score)) {
    localStorage.setItem(MINIMUM_RELATIVE_SEARCH_SCORE_STORAGE_KEY, String(score));
  }
};

export const filterSearchResults = <T extends ScoredSearchResult>(
  items: T[],
  minimumRelativeScore: number,
): T[] => {
  const leadingScore = items[0]?.score;

  if (typeof leadingScore !== 'number' || !Number.isFinite(leadingScore) || leadingScore <= 0) {
    return items;
  }

  const minimumScore = leadingScore * minimumRelativeScore;
  const scoreTolerance = Number.EPSILON * Math.max(1, Math.abs(minimumScore));

  return items.filter((item, index) => (
    index === 0 ||
    typeof item.score !== 'number' ||
    item.score + scoreTolerance >= minimumScore
  ));
};
